import { Modal } from 'antd';
import React from 'react';

const ReplaceLibrarianModal = ({ open, message, loading, onConfirm, onCancel }) => (
  <Modal
    title="Replace librarian?"
    open={open}
    okText="Replace"
    cancelText="Cancel"
    onOk={onConfirm}
    onCancel={onCancel}
    okButtonProps={{ loading }}
    destroyOnClose
  >
    <p>{message}</p>
    <p className="m-0">
      They will be removed from this library and this user will become its
      librarian.
    </p>
  </Modal>
);

export default ReplaceLibrarianModal;
